<template>
  <v-container 
    :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-5 py-0': $vuetify.breakpoint.mdAndUp,
    }"
  >
    <v-layout justify-center
      ><!--este manda que no se me olvide-->
      <v-flex md8>
        <v-form ref="form">
          <!--STEPPER-->
          <v-stepper v-model="a1" flat>
            <v-stepper-header style="display: none">
              <v-stepper-step
                :complete="a1 > 1"
                step="1"
                complete-icon="fas fa-check subheading"
                edit-icon="fas fa-check subheading"
                error-icon="fas fa-exclamation-triangle subheading"
                color="#9D4593"
                editable
              >
              </v-stepper-step>
              <v-stepper-step
                :complete="a1 > 2"
                step="2"
                complete-icon="fas fa-check subheading"
                edit-icon="fas fa-check subheading"
                error-icon="fas fa-exclamation-triangle subheading"
                color="#9D4593"
                editable
              ></v-stepper-step>
              <v-stepper-step
                :complete="a1 > 3"
                step="2"
                complete-icon="fas fa-check subheading"
                edit-icon="fas fa-check subheading"
                error-icon="fas fa-exclamation-triangle subheading"
                color="#9D4593"
                editable
              ></v-stepper-step>
            </v-stepper-header>

            <!--INICIO CONTENIDO DE LOS STEPS-->
            <v-stepper-content step="1" flat>
              <!--ORIGEN-->

              <v-flex 
                :class="{
                  'px-0': $vuetify.breakpoint.smAndDown,
                  'px-2 py-5': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <v-toolbar color="#9D4593" dark>
                  <img
                    :src="
                      require('../../../../assets/static/img/direccion-o-d.png')"
                      alt="icono de direcciones"
                    style="width: 30px; margin-right: 16px"
                  />
                  <v-toolbar-title>Dirección de Origen</v-toolbar-title>
                </v-toolbar>
                <v-flex
                  :class="{
                    'px-0': $vuetify.breakpoint.smAndDown,
                    'px-2 py-5': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                <!--direccionorigen-->
                  <v-layout sm10>
                    <v-flex class="d-flex">
                      <v-text-field
                        label="Ingresa calle, número y luego selecciona la sugerencia"
                        v-model="datos.direccion_origen.direccion"
                        id="starting_address"
                        :rules="rules.direccionOrigen"
                        placeholder="Sólo Calle y Número"
                        v-on:change="datos.direccion_origen.marker = {}"
                        required
                        :disabled="campoDeshabilitado" 
                        
                      >
                      </v-text-field>

                      <v-btn
                        class="btn-editar"
                        icon
                        dark
                        :disabled="campoDeshabilitado == false" 
                        @click="campoDeshabilitado ? campoDeshabilitado = false : campoDeshabilitado = true"
                        >
                        <v-img
                          style="max-heigth: 75px; max-width: 75px"
                          :src="require('../../../../assets/static/img/LapizInvertido.png')"
                           alt="imagen lapiz invertido">
                        </v-img>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <!--esconder esto-->
                  <v-flex v-show="Origen2" sm10>
                    <v-layout justify-center>
                      <v-flex
                        sm10
                        sm12
                        :class="{
                          'px-0': $vuetify.breakpoint.smAndDown,
                          'px-2 py-3': $vuetify.breakpoint.mdAndUp,
                        }"
                      >
                        <h3 id="texto-orige-detino">
                          ¿Qué tipo de inmueble es?
                        </h3>
                        <!--HERE-->
                        <v-select
                          :items="items"
                          append-icon="fas fa-caret-down"
                          label="tipo de propiedad"
                          :rules="rules.required"
                          v-model="datos.origen.tipo"
                          @change="cambio()"
                        ></v-select>
                        <v-text-field
                          :label="tipoPropiedad"
                          color="#9D4593"
                          v-model="datos.origen.numero"
                          
                        ></v-text-field>
                        <v-text-field
                          v-model="datos.origen.piso"
                          type="number"
                          label="Piso"
                          color="#9D4593"
                          required
                          :min="1"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>            
                  </v-flex>
                  
                    <v-layout v-show="Origen2" justify-end>
                        <v-btn
                          color="#9D4593"
                          @click="a1 = 2"
                          dark
                          :disabled="datos.direccion_origen.direccion === ''"
                          ><!--@click="validate(true, 'Mudanza_Paso_1',)" click original-->
                          Siguiente
                        </v-btn>  
                    </v-layout> 
                  <!--<GmapMap
														:center="Object.keys(this.datos.direccion_origen.marker).length > 0 ? this.datos.direccion_origen.marker : {lat: -33.437637, lng: -70.650471}"
														:zoom="15"
														style="width: 100%; height: 200px"
													>
														<GmapMarker
															v-if="Object.keys(this.datos.direccion_origen.marker).length > 0"
															:position="datos.direccion_origen.marker" />
														/>
													</GmapMap>-->

                  <!--Aqui termina el menu del step 2-->

                  <!--FIN ORIGEN-->
                  <!-- inicio del boton para volver al anterior-->
                  <v-flex text-xs-center >
                    <v-btn
                      color="grey"
                      dark
                      @click="retroceder()"
                      style="margin-top: 10px;"
                    >
                      Ir a Elementos
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-stepper-content>

            <v-stepper-content step="2" flat>
              <!--Destino-->
                <v-flex
                  :class="{
                    'pa-0': $vuetify.breakpoint.smAndDown,
                    'pr-2 py-5': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                  <v-toolbar color="#9D4593" dark>
                    <img
                      :src="
                        require('../../../../assets/static/img/direccion-o-d.png')"
                        alt="icono de las direcciones"
                      style="width: 30px; margin-right: 16px"
                    />
                    <v-toolbar-title>Dirección Destino</v-toolbar-title>
                  </v-toolbar>
                  
                  <!--direccion destino-->
                  <v-flex
                  :class="{
                    'px-0': $vuetify.breakpoint.smAndDown,
                    'px-2 py-5': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                  <v-layout sm10>
                    <v-flex class="d-flex">
                      <v-text-field
                        label="Ingresa calle, número y luego selecciona la sugerencia"
                        v-model="datos.direccion_destino.direccion"
                        id="destination_address"
                        :rules="rules.direccionDestino"
                        placeholder="Sólo Calle y Número"
                        v-on:change="datos.direccion_destino.marker = {}"
                        required
                        :disabled="campoDeshabilitadoD" 
                      ></v-text-field>
                      <v-btn
                        class="btn-editar-destino"
                        icon
                        dark
                        :disabled="campoDeshabilitadoD == false" 
                        @click="campoDeshabilitadoD ? campoDeshabilitadoD = false : campoDeshabilitadoD = true">
                        <v-img
                          style="max-heigth: 75px; max-width: 75px;"
                          :src="require('../../../../assets/static/img/LapizInvertido.png')"
                           alt="imagen del lapiz invertido">
                        </v-img>
                      </v-btn>
                    </v-flex>
                  </v-layout> 
              
                <v-flex v-show="Destino2" sm10>
                    <v-layout justify-center>
                      <v-flex
                        sm10
                        sm12
                        :class="{
                          'px-0': $vuetify.breakpoint.smAndDown,
                          'px-2 py-3': $vuetify.breakpoint.mdAndUp,
                        }"
                      >
                        <h3 id="texto-orige-detino">
                          ¿Qué tipo de inmueble?
                        </h3>

                        <v-select
                          :items="items"
                          append-icon="fas fa-caret-down"
                          label="tipo de propiedad"
                          :rules="rules.required"
                          v-model="datos.destino.tipo"
                          @change="cambioD()"
                        ></v-select>
                        <v-text-field
                          :label="tipoPropiedad2"
                          color="#9D4593"
                          v-model="datos.destino.numero"
                        ></v-text-field>
                        <v-text-field
                          v-model="datos.destino.piso"
                          type="number"
                          label="Piso"
                          color="#9D4593"
                          required
                          :min="1"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-layout v-show="Destino2" align-center justify-space-between>
                          <v-btn color="#9D4593" @click="a1 = 1" dark>
                          Anterior
                        </v-btn>
                        <v-btn
                          color="#9D4593"
                          dark
                          :disabled="datos.direccion_origen.direccion === ''"
                          @click="a1 = 3"
                        >
                          Siguiente
                        </v-btn>
                      </v-layout>
                  <v-flex text-xs-center >
                    <v-btn
                      color="grey"
                      dark
                      @click="retroceder()"
                      style="margin-top: 10px;"
                    >
                      Ir a Elementos
                    </v-btn>
                  </v-flex>
                  </v-flex>
                </v-flex>
            </v-stepper-content>
            <v-stepper-content step="3" flat>
              <v-toolbar color="#9D4593" dark>
                    <v-toolbar-title>Fecha y Hora</v-toolbar-title>
                  </v-toolbar>
              <v-flex md12 sm12 xs12 px-3>
                  <v-menu
                      ref="menuDate"
                      :close-on-content-click="true"
                      v-model="menu"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      class="mb-5">
                      <v-text-field
                          slot="activator"
                          v-model="datos.first.date"
                          label="Seleccione Fecha"
                          :min="tomorrow"
                          color="#1f97b9"
                          readonly
                          :rules="rules.nameRules"
                      >
                          <img :src='require("../../../../assets/static/img/fecha.png")' alt="icono de fecha" style="width: 25px;height:25px;" slot="prepend">
                      </v-text-field>
                      <v-date-picker
                          v-model="datos.first.date"
                          :min="tomorrow"
                          no-title
                          scrollable
                          prev-icon="fas fa-chevron-left caption"
                          next-icon="fas fa-chevron-right caption"
                          locale="es-mx"
                          first-day-of-week="1"
                          style="min-height: 380px;"
                      >
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="menu = false">Cancelar</v-btn>
                      </v-date-picker>
                  </v-menu>
                  <v-progress-linear v-show="!mantenedores.tiempo_minimo" :indeterminate="true" color="#1f97b9"></v-progress-linear>
                  <div v-show="mantenedores.tiempo_minimo" class="flex-hour-container v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-readonly theme--light">
                  <div class="v-input__prepend-outer">
                      <img :src='require("../../../../assets/static/img/hora.png")' alt="icono de horario" style="width: 25px;height:25px;">
                  </div>
                  <div class="hour-picker-container">
                      <v-select
                          v-model="datos.first.time"
                          :items="horas"
                          @input="validTimeDiff"
                          :rules="rules.nameRules"
                          append-icon="fas fa-caret-down"
                          label="Seleccione Hora"
                      ></v-select>
                  </div>
                  <v-tooltip right v-model="showTooltip" max-width="350px" :color="typeTooltip == 'warning' ? '#616161' : 'red'">
                  </v-tooltip>
                  </div>
                  <!-- <p style="font-size: 12px; color: #ff9c55">Para agendar un servicio dentro de las siguientes 24 horas debe confirmar disponibilidad via WhatsApp <a href="https://wa.me/56965909598" target="_blank" style="color: black">aqui</a></p> -->
                  <v-layout v-show="Destino2" align-center justify-space-between>
                          <v-btn color="#9D4593" @click="a1 = 2" dark>
                          Anterior
                        </v-btn>
                        <v-btn
                          color="#9D4593"
                          dark
                          :disabled="datos.direccion_origen.direccion === ''"
                          @click="validate(true)"
                        >
                          Siguiente
                        </v-btn>
                      </v-layout>
                  <v-flex text-xs-center >
                    <v-btn
                      color="grey"
                      dark
                      @click="retroceder()"
                      style="margin-top: 10px;"
                    >
                      Ir a Elementos
                    </v-btn>
                  </v-flex>
              </v-flex>
            </v-stepper-content>
            <!--FIN CONTENIDO DE LOS STEPS-->
          </v-stepper>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from "../../../../events.js";
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
export default {
  name: "nombre",

  data() {
    return {
      
      horas: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'],
      mantenedores: {},
      tomorrow: '',
      menu: false,
      a1: 0,
      tipoPropiedad: 'Número - Letra del o la casa',
      tipoPropiedad2: 'Número - Letra del o la casa',
      campoDeshabilitado: false,
      campoDeshabilitadoD: false,
      Origen1: true,
      Origen2: false,
      Destino2: false,
      direcciones: {
        destino: '',
        origen: ''
      },
      datos: {
        direccion_origen: {
          direccion: "",
          marker: {},
          direccion_obj: {},
          estacionamiento: "",
        },
        origen: {
          tipo: "Casa",
          piso: 1,
          numero: "",
          mover: "Primer Piso a Primer Piso",
          acopio: {
            distancia: 0,
            valor: 2000,
          },
        },
        direccion_destino: {
          direccion: "",
          marker: {},
          direccion_obj: {},
          estacionamiento: "",
        },
        destino: {
          tipo: "Casa",
          piso: 1,
          numero: "",
          mover: "Primer Piso a Primer Piso",
          acopio: {
            distancia: 0,
            valor: 2000,
          },
        },
        first: {
          date: '',
          time: ''
        }
      },
      items: ["Casa", "Departamento", "Local", "Parcela", "Condominio"],
      tipoSeleccionado: null,
      rules: {
        control: false,
        required: [(v) => !!v || "Campo obligatorio"],
        direccionOrigen: [
          (v) => !!v || "Campo obligatorio",
          (v) =>
            !!/\d/.test(v) ||
            !this.control ||
            "Por favor ingresa también la numeración.",
          (v) => {
            if (Object.keys(this.datos.direccion_origen.marker).length > 0) {
              this.Origen2 = true;
              this.campoDeshabilitado ? this.campoDeshabilitado = false : this.campoDeshabilitado = true  

              return true;
            } else {
              return this.control
                ? "Debe seleccionar una dirección sugerida por Google"
                : true;
            }
          },
        ],
        direccionDestino: [
          (v) => !!v || "Campo obligatorio",
          (v) =>
            !!/\d/.test(v) ||
            !this.control ||
            "Por favor ingresa también la numeración.",
          (v) => {
            if (Object.keys(this.datos.direccion_destino.marker).length > 0) {
              this.Destino2 = true;
              this.campoDeshabilitadoD ? this.campoDeshabilitadoD = false : this.campoDeshabilitadoD = true  
              return true;
            } else {
              return this.control
                ? "Debe seleccionar una dirección sugerida por Google"
                : true;
            }
          },
        ],
      },
      typeTooltip: 'warning',
      showTooltip: false,
    };
  },
  methods: {
    validTimeDiff(){
        this.datetimeOK = true
        const now = this.$moment()
        let hour_selected = this.$moment(this.datos.first.date + ' ' + this.datos.first.time, this.$moment.defaultFormat)
        let hour_limit = this.$moment().add(this.mantenedores.tiempo_minimo, 'seconds')
        this.time_diff = hour_selected.diff(hour_limit, 'seconds')
        if (this.time_diff <= 0 && this.mantenedores){
            if(!this.mantenedores.tiempo_minimo){
                return true
            }
            this.typeTooltip = 'danger'
            this.colorTooltipActivator = 'red'
            if(this.dialogPago){
                this.showTooltip = true
            }
            else{
                this.showTooltip = false
            }
            this.datetimeOK = false
            return false
        }
        else{
            this.colorTooltipActivator = '#1f97b9'
            this.typeTooltip = 'warning'
            return true
        }
    },
    get_mantenedores(){
        let db = firebase.firestore()
        let self = this
        db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
                if (doc.exists) {
                        self.mantenedores = doc.data()
                        self.setInitialHour()
                        //self.initHoursPicker()
                        EventBus.$emit('emmitMantenedores', self.mantenedores);
                } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                }
        }).catch(function(error) {
                console.log("Error getting document:", error);
        });
    },
    setInitialHour(){
        const today = new Date()
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)
        this.datos.first.date = tomorrow.toISOString().substr(0, 10)
        const date = this.$moment().add(this.mantenedores.tiempo_minimo/3600,'h').add(5,'m')
        let horas = date.hour()
        let minutos = date.minute()
        if(minutos == 0 || minutos == 15 || minutos == 30 || minutos == 45 ){}
        else if(minutos < 15){ minutos = 15 }
        else if(minutos < 30){ minutos = 30 }
        else if(minutos < 45){ minutos = 45 }
        else if(minutos < 60){
            if(minutos > 45){
                minutos = 0
                horas++
                if(horas == 24){horas = 0}
            }
        }
        let h = horas.toString()
        let m = minutos.toString()
        if(horas < 10){ h = '0' + horas.toString() }
        if(minutos < 10){ m = '0' + minutos.toString() }
        this.datos.first.time = h + ':' + m
    },
    cambio() {
            this.tipoPropiedad = 'Número - Letra del/la ' + this.datos.origen.tipo
        },
    cambioD() {
            this.tipoPropiedad2 = 'Número - Letra del/la ' + this.datos.destino.tipo
        },
    retroceder() {
      this.eventTracker('goBackThird')
      EventBus.$emit("retrocederDemo", 2);
    },

    validate(move) {
      if (this.datos.direccion_origen.direccion !== "" && this.datos.direccion_destino.direccion !== "") {
        var data = {
          datos: this.datos,
          valid: true,
          move,
        }
        if (move) {
          this.eventTracker('goForwardThird')
          EventBus.$emit("mudanzaThirdDemo", data)
        }
      }
    },
    eventTracker(tipo) {
        gtag('event', tipo, {
          'event_category' : tipo,
          'event_label' : tipo
        })
    },
    setAddress(data){
				// Seteamos la data de dirección como promesa para poder esperar que esto esté listo en retomarPedido abajo
      return new Promise((resolve, reject) => {
          const self = this
          const geocoder = new google.maps.Geocoder()
          const origen = new Promise((resolve, reject) => {
              geocoder.geocode({'address': data.direcciones.origen}, function(results, status) {
              if (status === 'OK') {
                  self.datos.direccion_origen.marker = results[0].geometry.location
              } else {
                  alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
              })
          })
          const destino = new Promise((resolve, reject) => {
            geocoder.geocode({'address': data.direcciones.destino}, function(results, status) {
              if (status === 'OK') {
                self.datos.direccion_destino.marker = results[0].geometry.location
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
              resolve(true)
            })	
          })

          Promise.all([origen, destino]).then(values => { 
            resolve(true)
          });
        })  
      }
     
  },
  mounted() {
    this.get_mantenedores()
    this.$gmapApiPromiseLazy().then(() => {
      let self = this;
      let options = {
        componentRestrictions: { country: "cl" },
      };

      //Origen
      let starting_address_input = document.getElementById("starting_address");
      let starting_address_autocomplete = new google.maps.places.Autocomplete(
        starting_address_input,
        options
      );
      starting_address_autocomplete.addListener("place_changed", function () {
        let place = starting_address_autocomplete.getPlace();

        self.datos.direccion_origen.direccion_obj = place;
        self.datos.direccion_origen.marker = place.geometry.location;
        self.datos.direccion_origen.direccion = place.formatted_address;
      });
      let destination_address_input = document.getElementById(
        "destination_address"
      );
      let destination_address_autocomplete =
        new google.maps.places.Autocomplete(destination_address_input, options);

      destination_address_autocomplete.addListener(
        "place_changed",

        function () {
          let place = destination_address_autocomplete.getPlace();
          self.datos.direccion_destino.direccion_obj = place;
          self.datos.direccion_destino.marker = place.geometry.location;
          self.datos.direccion_destino.direccion = place.formatted_address;
        }
      );
    });
    EventBus.$on('retomarPedidoThirdDemo', data => {
      this.datos.origen = data.third.origen
      this.datos.destino = data.third.destino
      this.datos.direccion_origen.direccion = data.first.direccion_origen.direccion
      this.datos.direccion_destino.direccion = data.first.direccion_destino.direccion
      this.direcciones.origen = data.first.direccion_origen.direccion
      this.direcciones.destino = data.first.direccion_destino.direccion
      const dataDireccion = {
        direcciones: this.direcciones
      }
      this.setAddress(dataDireccion)
      this.a1 = 2
      EventBus.$emit('avanzarRetomarDemo', {e1: 4})
    })
  },
};
</script>